import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Landing from "@/pages/Landing";
import Pricing from "@/pages/Pricing";
import Checkout from "@/pages/Checkout";
import Institutions from "@/pages/Institutions";
import SampleReport from "@/pages/SampleReport";
import CandidateFlow from "@/pages/CandidateFlow";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Toaster position="top-right" richColors />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/checkout" element={<Checkout />} />
          <Route path="/institutions" element={<Institutions />} />
          <Route path="/sample-report" element={<SampleReport />} />
          <Route path="/take-test" element={<CandidateFlow />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminDashboard />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
